export const ReasonEnum = {
  NONE: 0,
  TECHNOLOGY_UPDATE: 1,
  LOSS_OR_THEFT: 2,
  DEFECT: 3
}

export const ReasonLabelConfigEnum = {
  [ReasonEnum.NONE]: '',
  [ReasonEnum.TECHNOLOGY_UPDATE]: 'change-reason-tech-change',
  [ReasonEnum.LOSS_OR_THEFT]: 'change-reason-lost',
  [ReasonEnum.DEFECT]: 'change-reason-defect'
}

export const ReasonLabelName = {
  [ReasonEnum.NONE]: '',
  [ReasonEnum.TECHNOLOGY_UPDATE]: 'Mudança tecnologia',
  [ReasonEnum.LOSS_OR_THEFT]: 'Perda/Roubo',
  [ReasonEnum.DEFECT]: 'Defeito'
}
